export enum LayoutRoutes {
  Header = 'header',
}
